import { getItemsFromCollection } from "directus/src/operations";

export async function fetchRecurringJobConfig({ jobId }) {
  try {
    const query = {
      fields: [
        "id",
        "amount",
        "currency",
        "billing_interval",
        "billing_frequency",
        "billing_by_week_day",
        "billing_by_month_date",
        "billing_by_month",
        "budget_margin"
      ],
      filter: {
        job: {
          _eq: jobId,
        },
      },
    };

    const response = await getItemsFromCollection(
      "recurring_job_config",
      query,
    );
    const item = response[0];
    if (item) {
      if (typeof item.amount === "string") item.amount = Number(item.amount);
      if (typeof item.billing_interval === "string") item.billing_interval = Number(item.billing_interval);
      if (typeof item.billing_by_week_day === "string") item.billing_by_week_day = Number(item.billing_by_week_day);
      if (typeof item.billing_by_month_date === "string") item.billing_by_month_date = Number(item.billing_by_month_date);
      if (typeof item.billing_by_month === "string") item.billing_by_month = Number(item.billing_by_month);
    }
    return item;
  } catch (error) {
    console.error("Error fetching recurring config:", error);
    throw error;
  }
}
